module.exports = __webpack_public_path__ + "img/isalogo_notext_disconnected.9eb389cd.png";